import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
  Outlet,
} from "react-router-dom";
import { Checkout } from "@/pages/checkout";
import { ErrorBoundary } from "@/components/error-boundary";
import { AppInitializer } from "./components/app-initializer";
import { CreditCheckDeniedPage } from "@/pages/denied";

const router = createBrowserRouter(
  [
    {
      element: (
        <AppInitializer>
          <Outlet />
        </AppInitializer>
      ),
      errorElement: <ErrorBoundary />,
      // Added for v7 partial hydration support - can be removed when v7 is released
      HydrateFallback: ErrorBoundary,
      children: [
        {
          path: "/",
          element: <Navigate to="/en" replace />,
        },
        {
          path: ":lang",
          children: [
            {
              index: true,
              element: <Navigate to="/" replace />,
            },
            {
              path: ":orderId",
              children: [
                {
                  index: true,
                  element: <Checkout />,
                  loader: ({ params }) => {
                    return { params };
                  },
                },
                {
                  path: "nekad",
                  element: <CreditCheckDeniedPage />,
                },
              ],
            },
          ],
        },
        {
          path: "*",
          element: <Navigate to="/en" replace />,
        },
      ],
    },
  ],
  {
    future: {
      // For SSR frameworks to provide partial hydration data
      // TODO: Remove when upgrading to React Router v7
      v7_partialHydration: true,

      // Changes how relative paths work with splat routes (dashboard/*)
      // TODO: Remove when upgrading to React Router v7
      v7_relativeSplatPath: true,

      // Makes form methods uppercase (GET/POST) to match fetch() behavior
      // TODO: Remove when upgrading to React Router v7
      v7_normalizeFormMethod: true,

      // Makes fetchers persist until idle instead of component unmount
      // TODO: Remove when upgrading to React Router v7
      v7_fetcherPersist: true,

      // Prevents automatic loader revalidation on 4xx/5xx action errors
      // TODO: Remove when upgrading to React Router v7
      v7_skipActionErrorRevalidation: true,
    },
  }
);

export function AppRoutes() {
  return (
    <RouterProvider
      router={router}
      future={{
        // Uses React.useTransition for router state updates
        // TODO: Remove when upgrading to React Router v7
        v7_startTransition: true,
      }}
    />
  );
}
